
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-linear-genome-view.cjs.production.min.js')
} else {
  module.exports = require('./react-linear-genome-view.cjs.development.js')
}
